
export default {
    experiencia: {},
    experiencias: []
}